import type { Company } from "kubb";
import type { CompanyType } from "kubb";
import type { User } from "kubb";
import { companyRoleEnum, userTypeEnum } from "kubb";
import { useForceViewerMode } from "reducers/viewerMode";
import { useSelectedCompany } from "../../hooks/useCompany";
import { userHasTypeForCompany } from "../../model/user";
import { useProfile } from "../useProfile";

export default function useUserHasRoles(
  userTypes: string | string[],
  companyType?: CompanyType[],
  ignoreForceViewerMode = false,
): boolean {
  const user = useProfile();
  const company = useSelectedCompany();
  const forceViewerMode = useForceViewerMode();
  return userHasRole(
    user,
    company,
    userTypes,
    forceViewerMode && !ignoreForceViewerMode,
    companyType,
  );
}

export function userHasRole(
  user: User | undefined,
  company: Company | undefined,
  userTypes: string | string[],
  forceViewerMode = false,
  companyType?: CompanyType[],
): boolean {
  if (user) {
    if (user.user_type === userTypeEnum.superadmin) {
      if (forceViewerMode) {
        return userTypes.includes(companyRoleEnum.viewer);
      } else {
        return true;
      }
    } else if (
      company &&
      (!companyType ||
        (company && companyType.includes(company.company_type))) &&
      userHasTypeForCompany(user, company.company_id, userTypes)
    ) {
      return true;
    }
  }
  return false;
}
